module.exports = __webpack_public_path__ + "static/media/close.934c4baa.svg";